// src/forceLogout.js
import { LARAVEL_BASE } from './config';

let inProgress = false;

export function forceLogout(msg = 'คุณไม่มีสิทธิเข้าถึงหน้า/เมนูนี้ กรุณาติดต่อผู้ดูแลระบบ \nYou do not have permission to access this page/menu. Please contact the administrator.') {
    if (inProgress) return;      // กันเรียกซ้ำจากหลายจุด/StrictMode
    inProgress = true;

    try { alert(msg); } catch (_) {}

    const ret = encodeURIComponent(window.location.href);
    // ใช้ replace เพื่อลดโอกาสย้อนกลับแล้วลูป
    window.location.replace(
        `${LARAVEL_BASE}/force-logout?msg=${encodeURIComponent(msg)}&returnUrl=${ret}`
    );
}
